<template>
  <div>
    <div class="vg-content">
      <van-image class="logo" width="100" height="50" :src="srcLogo"/>
      <van-image style="margin-top: 110px;" width="100" height="100" :src="srcSuccess"/>
      <div class="text">支付成功</div>
    </div>
    <vg-button-group-fixed>
      <vg-button
          type="primary"
          @click="returnToMyElectronicPass"
      >
        返回首页
      </vg-button>
    </vg-button-group-fixed>
  </div>
</template>

<script>
import {Image as VanImage} from "vant";
import VgButton from "@/components/Commons/VgButton";
import srcLogo from "@/assets/login/kaidelogo.png";
import srcSuccess from "@/assets/scanverify/pay-success.svg";
import VgButtonGroupFixed from "@/components/Commons/VgButtonGroupFixed";

export default {
  name: "PayResult",
  components: {
    VanImage,
    VgButton,
    VgButtonGroupFixed,
  },
  data() {
    return {
      srcLogo: srcLogo,
      srcSuccess: srcSuccess,
      passCardType: "",
      phoneNum: "",
      id: "", // applicationSituationId
      btnStr: "查看我的电子出入证",
    }
  },
  created() {
    console.log(this.$route);
    this.passCardType = this.$route.query.passCardType;
    this.phoneNum = this.$route.query.phoneNum;
    this.id = this.$route.query.id;
    this.btnStr = this.passCardType === "TENANT_EMPLOYEE" ? "查看我的电子出入证" : "查看申请记录详情";
  },
  methods: {
    returnToApplication() {
      this.$router.replace({path: `/digital-passes/applications/${this.id}`});
    },
    returnToMyElectronicPass() {
      this.$router.replace({path: '/myElectronicPass'});
    }
  },
}
</script>

<style scoped>
.vg-content {
  margin: 15px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: center;
}

.logo {
  align-self: flex-start;
}

.text {
  margin-top: 40px;
  color: #4BA9F6;
  font-size: 36px;
  font-weight: bold;
}

</style>